import { randomChar } from "./randomChar";

export const generateString = (
  str: string,
  step: number,
  max: number = str.length,
  min: number = 0
): string => {
  const n = max - min;
  if (n <= step) return str;

  const output = str.split("").map((char, i) => {
    if (i < min) return char;
    if (i >= max) return char;
    if (i < min + step) return char;
    return randomChar();
  });

  return output.join("");
};
